import objectGetItems from "./getItems";

const getData = (data, parameter) => {
  return objectGetItems(data, parameter);
};
export default getData;
